import React from 'react';

/**
 * Card Component - Reusable container with glassmorphism effect
 * 
 * @param {string} variant - 'default' | 'elevated'
 * @param {string} className - Additional CSS classes
 * @param {React.ReactNode} children - Card content
 */
const Card = ({
    variant = 'default',
    className = '',
    children,
    ...props
}) => {
    const baseStyles = 'rounded-xl backdrop-blur-md transition-all duration-200';

    const variantStyles = {
        default: 'bg-surface border border-white/10 shadow-lg',
        elevated: 'bg-surface-elevated border border-white/20 shadow-xl hover:shadow-2xl',
    };

    return (
        <div
            className={`${baseStyles} ${variantStyles[variant]} ${className}`}
            {...props}
        >
            {children}
        </div>
    );
};

export default Card;
